import { EChartsOption } from 'echarts';
import { dataViewFormatter, getTimestampedFileNameForWidget, formatLabelWithWrapping } from '../helpers/widgets';

interface KaupapaChartData {
  projectName: string;
  visitPurpose: string;
  totalObservations: number;
}

const getKaupapaChartConfig = (data: KaupapaChartData[]): EChartsOption => {
  const projectTotals = data.reduce((acc, item) => {
    if (!acc[item.projectName]) {
      acc[item.projectName] = 0;
    }
    acc[item.projectName] += item.totalObservations;
    return acc;
  }, {} as Record<string, number>);

  const minProjectCount = Math.min(...Object.values(projectTotals));
  const maxProjectCount = Math.max(...Object.values(projectTotals));
  const radarBoundary = Math.ceil(maxProjectCount + (maxProjectCount - minProjectCount) * 0.1);

  return {
    color: [
      '#f26b4b', // Orange
    ],
    title: {
      show: false,
    },
    toolbox: {
      feature: {
        dataView: {
          show: true,
          readOnly: true,
          optionToContent: (option: any): string | HTMLElement =>
            dataViewFormatter(option as EChartsOption, undefined, undefined, projectTotals),
        },
        saveAsImage: {
          show: true,
          name: getTimestampedFileNameForWidget('rongo-kaupapa'),
        },
      },
    },
    radar: {
      indicator: Object.keys(projectTotals).map((project) => ({
        name: project,
        max: radarBoundary,
      })),
      axisName: {
        formatter: function (value: string | undefined, indicator: any) {
          return formatLabelWithWrapping(value, 20); // Wrap labels longer than 10 characters
        },
        width: 10,
        color: '#26312b', // Charcoal
      },
      splitArea: {
        areaStyle: {
          color: [
            '#00b1d8', // Light blue
            '#5fc9de', // Light teal
          ],
          shadowColor: 'rgba(0, 0, 0, 0.2)',
          shadowBlur: 10,
        },
      },
      axisLine: {
        lineStyle: {
          color: 'rgba(211, 253, 250, 0.8)',
        },
      },
      splitLine: {
        lineStyle: {
          color: 'rgba(211, 253, 250, 0.8)',
        },
      },
    },
    series: [
      {
        name: 'Usage',
        type: 'radar',
        lineStyle: {
          width: 4,
        },
        symbolSize: 10,
        data: [
          {
            value: Object.values(projectTotals),
            name: 'Usage',
          },
        ],
      },
    ],
  };
};

export { getKaupapaChartConfig, KaupapaChartData };
